import { t } from '@/features/i18n/utils';
import { createFileRoute } from '@tanstack/react-router';
import { useSetAtom } from 'jotai';
import { Icon } from '@/ui/components/icon';
import { Briefcase08Icon, PlusSignIcon } from '@hugeicons-pro/core-stroke-rounded';
import { CompaniesTable } from '@/features/companies/components/companies-table';
import { createCompanyOpenAtom } from '@/features/companies/store';
import { CompanyType } from '@/features/companies/types';
import { companiesQuery } from '@/features/companies/queries';
import { Breadcrumb, BreadcrumbPage } from '@/ui/components/breadcrumb';
import { Header, HeaderBackButton, HeaderButton } from '@/ui/components/header';
import { MainScrollArea } from '@/ui/components/main';

export const Route = createFileRoute('/_authed/settings/suppliers')({
  component: RouteComponent,
  loader: async ({ context }) => {
    await context.queryClient.query({
      ...companiesQuery(context.auth.user.organizationId, CompanyType.SUPPLIER),
      staleTime: 'static',
    });
  },
});

function RouteComponent() {
  const setCreateDialogOpen = useSetAtom(createCompanyOpenAtom);

  return (
    <>
      <Header>
        <HeaderBackButton to="/" />
        <Breadcrumb>
          <BreadcrumbPage>
            <Icon icon={Briefcase08Icon} />
            {t({ en: 'Suppliers', nb: 'Leverandører' })}
          </BreadcrumbPage>
        </Breadcrumb>
        <HeaderButton
          aria-label={t({ en: 'Add new', nb: 'Legg til ny' })}
          onClick={() => setCreateDialogOpen(true)}
        >
          <Icon icon={PlusSignIcon} />
        </HeaderButton>
      </Header>
      <MainScrollArea>
        <CompaniesTable type={CompanyType.SUPPLIER} />
      </MainScrollArea>
    </>
  );
}
